
import { Options, Vue, prop } from "vue-class-component";
import { LastBalanceController } from "@/app/ui/controllers/LastBalanceController";
import { formatDateNumber, formatDateWithoutTime } from "@/app/infrastructures/misc/Utils";
import DropdownFilter from "./DropdownFilter.vue";
import BalanceRangeFilter from "./BalanceRangeFilter.vue";
import { RequestListLastBalanceV2 } from "@/data/payload/api/LastBalanceV2ApiRequest";
import DownloadRequest from "@/app/ui/components/widget-download-request/index.vue";
import ModalDownload from "./modal-download.vue";
import { LastBalanceDownloadRequest } from "@/domain/entities/LastBalance";

class Props {
  placeholderSearch = prop<string>({
    default: ""
  });
  tab = prop<string>({
    default: ""
  });
  columns = prop<Array<any>>({
    default: []
  });
}

@Options({
  components: {
    DropdownFilter,
    BalanceRangeFilter,
    DownloadRequest,
    ModalDownload
  }
})

export default class PageListLastBalance extends Vue.with(Props) {
  showModalDownload = false
  // TODO: buat modal data untuk modalDownload
  // bisa pakai LastBalanceDownloadRequest entity yang sudah di import diatas sebagai rujukan
  /* 
    example ModalDownload:
    <ModalDownload
      v-model:show="showModalDownload"
      :modalTitle="`Download data`"
      :modalData="*modalData dengan entity LastBalanceDownloadRequest disini*"
    />
  
  */

  statusSaldo = "";
  sortSaldo = "";
  minBalance: string | null = null;
  maxBalance: string | null = null;
  periode: any = { startDate: null, endDate: null };
  periodeRaw: any = { startDate: null, endDate: null };

  statusOptions = [
    { name: "Semua", value: "all" },
    { name: "Saldo minus", value: "minus" },
    { name: "Saldo plus", value: "plus" }
  ];

  sortOptions = [
    { name: "Tertinggi", value: "highest" },
    { name: "Terendah", value: "lowest" }
  ];

  onShowModalDownload() {
    this.showModalDownload = !this.showModalDownload;
  }

  fetchLastBalanceList() {
    const requestBalanceRequestModel = new RequestListLastBalanceV2();
    requestBalanceRequestModel.actorType = this.tab as any;
    requestBalanceRequestModel.page = this.lastBalanceList.pagination.page;
    requestBalanceRequestModel.limit = this.lastBalanceList.pagination.limit;
    requestBalanceRequestModel.name = this.searchValue;
    requestBalanceRequestModel.balanceStatus = this.statusSaldo;
    requestBalanceRequestModel.balanceFrom = this.minBalance ?? "";
    requestBalanceRequestModel.balanceTo = this.maxBalance ?? "";
    requestBalanceRequestModel.lastTrxDateFrom = this.periodeRaw.startDate
      ? formatDateNumber(this.periodeRaw.startDate)
      : "";
    requestBalanceRequestModel.lastTrxDateTo = this.periodeRaw.endDate
      ? formatDateNumber(this.periodeRaw.endDate)
      : "";
    requestBalanceRequestModel.sort = this.sortSaldo ?? "";
    LastBalanceController.fetchLastBalanceListV2(requestBalanceRequestModel);
  }
  get lastBalanceList() {
    return LastBalanceController.lastBalanceListV2;
  }
  get isLoading() {
    return LastBalanceController.isLoading;
  }
  get isError() {
    return LastBalanceController.isError;
  }
  get errorCause() {
    return LastBalanceController.errorCause;
  }
  get firstRequest() {
    return LastBalanceController.firstRequest;
  }

  // search
  get searchValue() {
    return LastBalanceController.search;
  }
  set searchValue(value: string) {
    LastBalanceController.setSearch(value);
  }

  onSearchLastBalance(value: string) {
    LastBalanceController.setFirstPage();
    this.searchValue = value;
    this.fetchLastBalanceList();
  }

  onClearSearchLastBalance() {
    LastBalanceController.setFirstPage();
    this.onSearchLastBalance("");
  }

  onApplyBalanceRange(range: { min: string | null; max: string | null }) {
    LastBalanceController.setFirstPage();
    this.minBalance = range.min;
    this.maxBalance = range.max;
    this.fetchLastBalanceList();
  }

  onApplyStatusFilter() {
    LastBalanceController.setFirstPage();
    this.fetchLastBalanceList();
  }

  onApplySortFilter() {
    LastBalanceController.setFirstPage();
    this.fetchLastBalanceList();
  }

  onResetBalanceRange() {
    LastBalanceController.setFirstPage();
    this.minBalance = null;
    this.maxBalance = null;
    this.fetchLastBalanceList();
  }

  setPeriode(payload: any) {
    LastBalanceController.setFirstPage();
    this.periodeRaw = {
      startDate: payload[0] || null,
      endDate: payload[1] || null
    };
    this.periode = {
      startDate: payload[0] ? formatDateWithoutTime(payload[0]) : null,
      endDate: payload[1] ? formatDateWithoutTime(payload[1]) : null
    };
    this.fetchLastBalanceList();
  }

  get modalDownloadData() {
    return new LastBalanceDownloadRequest({
      actorType: this.tab as any,
      saldoType: this.tab === "client_cod" ? "SALDOCOD" : "SALDO",
      balanceStatus: this.statusSaldo || "all",
      balanceFrom: this.minBalance ?? "",
      balanceTo: this.maxBalance ?? "",
      lastTrxDateFrom: this.periodeRaw.startDate
        ? formatDateNumber(this.periodeRaw.startDate)
        : "",
      lastTrxDateTo: this.periodeRaw.endDate
        ? formatDateNumber(this.periodeRaw.endDate)
        : "",
      sort: this.sortSaldo ?? ""
    });
  }
}
